export default __webpack_public_path__ + "static/media/studybuddy.6526e162.svg";